
import { MouseEventHandler } from "react";
import {
    ListItem,
    ListItemIcon,
    ListItemText,
    Typography
} from "@material-ui/core";
import {
    Asterisks,
    DisclosureIndicator,
    LottoBadge,
    NoteChip,
    Rating,
    ReminderChip,
    RoundBadge
} from './tasting-answer-item.styles';
import { styled } from "@material-ui/styles";

export type TastingAnswerItemProps = {
    roundIndex: number,
    selectedBeer: string|null,
    rating: number|null,
    hasAsterisk: boolean,
    hasDoubleAsterisk?: boolean,
    isLottoLoco?: boolean,
    showAsPoured: boolean,
    canEdit?: boolean,
    secondaryBeer?: string|null,
    note?: string|null,
    onClick?: MouseEventHandler
}

const BaseTastingAnswerItem = ({
    roundIndex,
    selectedBeer,
    rating,
    hasAsterisk,
    hasDoubleAsterisk = false,
    isLottoLoco = false,
    showAsPoured,
    canEdit=false,
    secondaryBeer = null,
    note = null,
    onClick,
    ...p
}: TastingAnswerItemProps) => {
    const hasNote = Boolean(note && note.trim().length > 0);
    return (
      <div {...p}>
        <ListItem
          onClick={canEdit ? onClick : undefined}
          divider
          button
          disabled={!canEdit}
        >
          <ListItemIcon className="round">
            <RoundBadge canEdit={canEdit}>{roundIndex + 1}</RoundBadge>
          </ListItemIcon>
          <ListItemText
            primary={
              <>
                {selectedBeer || "Choose Beer"}
                {!showAsPoured && hasAsterisk && <Asterisks double={hasDoubleAsterisk} />}
                {!showAsPoured && isLottoLoco && selectedBeer && <LottoBadge />}
              </>
            }
            secondary={
              !showAsPoured && (
                <>
                  <Typography
                    variant="caption"
                    color="textSecondary"
                  >
                    Rating: <Rating rating={rating} />
                    {secondaryBeer && <ReminderChip secondaryBeer={secondaryBeer} />}
                    {hasNote && <NoteChip note={note as string} />}
                  </Typography>
                </>
              )
            }
          />
          {canEdit && <DisclosureIndicator />}
        </ListItem>
      </div>
    );
}
const TastingAnswerItem = styled(BaseTastingAnswerItem)(({ theme }) => ({
  "& .round": {
    minWidth: 46,
  },
  "& .MuiListItemText-primary": {
    fontWeight: 700,
    fontSize: 15,
  },
}));

export default TastingAnswerItem;
